import App from 'app/app.js';
import 'app/store/UserProfileStore.js';
import 'app/service/RouterService.js';

function LtGuestSignInCtrl($scope, $filter, UserProfileStore, RouterService) {
  this.showIfNotLoggedIn = function () {
    return !UserProfileStore.isLoggedIn();
  };

  this.getPlaceholder = function (key) {
    return $filter('ltTranslateFilter')(key);
  };

  this.goLogin = function () {
    $scope.onWriteCache();
    RouterService.goToLogin(!!$scope.routeBackToPath ? $scope.routeBackToPath.replace('/', ':') : undefined);
  };

  this.isLinkPositionFirst = function () {
    return $scope.signInPosition === 'first' ? true : false;
  };

  this.validateInput = function (formName, inputcontrol, minlength, maxlength) {
    return $scope.validateInput({
      formName: formName,
      inputcontrol: inputcontrol,
      minlength: minlength,
      maxlength: maxlength
    });
  };

  this.checkDataExists = function () {
    return $('#guest-email-input').val();
  };

  this.validateEmail = function (inputcontrol, minlength, maxlength) {
    return $scope.validateEmail({
      inputcontrol: inputcontrol,
      minlength: minlength,
      maxlength: maxlength
    });
  };
}

App.controller('LtGuestSignInCtrl', ['$scope', '$filter', 'UserProfileStore', 'RouterService', LtGuestSignInCtrl]);
